import React, {useState, useCallback} from 'react';
import {LinkText} from '@/components/atoms';
import CustomDataTable from '@/components/organisms/CustomDataTable/CustomDataTable';
import {useActivites} from '@/containers/Activity/useActivites';
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '@/utils/constants/routesConstants';

const cellDataMapperObj = (navigate) => ({
  activityTitle: {
    cellData: ({row: {original} = {}}) => {
      const queryParam = `?review=${encodeURIComponent(original?.status)}`;
      return (
        <LinkText
          text={original?.activityTitle}
          id={original?.activityTitle + ' ' + original?.id || original?.uuid}
          handleClick={() =>
            navigate(
              `${ROUTES.ACTIVITY_VIEW.replace(':id', encodeURIComponent(original?.id || original?.uuid))}${queryParam}`
            )
          }
        />
      );
    },
    linkHandler: (row) => {
      const queryParam = `?review=${encodeURIComponent(row?.status)}`;
      return navigate(
        `${ROUTES.ACTIVITY_VIEW.replace(':id', encodeURIComponent(row?.id || row?.uuid))}${queryParam}`
      );
    },
    linkLabel: (row) => row.activityTitle || '—'
  },
  customers_count: ({row: {original} = {}}) => {
    return <div className='txtRightAlign'>{original?.numberOfCustomers}</div>;
  },
  percent_completed: ({row: {original} = {}}) => {
    return <div className='txtRightAlign'>{original?.percentageCompleted}</div>;
  },
  points_awarded: ({row: {original} = {}}) => {
    return <div className='txtRightAlign'>{original?.totalPointsAwarded}</div>;
  },
  status: ({row: {original} = {}}) => {
    return (
      <div className={original?.status === 'Cancelled' ? 'status_error' : ''}>
        {original?.status}
      </div>
    );
  }
});
export const SalesTargetsActivitiesList = () => {
  const {
    activityListData,
    activityLColConfigData,
    pageIndex,
    setPageIndex,
    setSortingObj,
    sortingObj,
    setSearchArry,
    onDownloadBtnClick,
    handleResetAll,
    isPending,
    isError
  } = useActivites();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rowSelected, setRowSelected] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const navigate = useNavigate();
  const cellDataMappedCols = getCellDataMappedCols(
    cellDataMapperObj(navigate),
    activityLColConfigData
  );

  const isLoading = isPending;

  const onDownloadClick = async (selectedRows, selectionMeta = {}) => {
    const ids =
      selectedRows?.length > 0
        ? selectedRows.map((item) => item?.id || item?.uuid)
        : [];
    const excludeIds = Array.isArray(selectionMeta?.excludeIds)
      ? selectionMeta.excludeIds
      : [];
    onDownloadBtnClick(ids, excludeIds);
  };

  const handleRowSelect = useCallback((selectedRecords, isAll) => {
    setRowSelected(selectedRecords);
    setIsSelectAll(isAll);
  }, []);

  return (
    <div className='salesTargetsActiviesDataTable'>
      <CustomDataTable
        columns={cellDataMappedCols}
        records={isError ? [] : activityListData?.data || []}
        isLoading={isLoading}
        pageSize={activityListData?.pageSize || 10}
        totalRecords={activityListData?.totalRecords || 0}
        paginationConfig={{
          pageIndex,
          setPageIndex
        }}
        sortingConfig={{
          handleSorting: setSortingObj,
          initialSortConfig: sortingObj
        }}
        filterConfig={{
          setSearchArry,
          onResetAll: handleResetAll
        }}
        selectionConfig={{
          onRowSelect: handleRowSelect,
          isSelectAll,
          globalSelectionEnable: true
        }}
        toolbarConfig={{
          onDownload: onDownloadClick,
          showDownload: true
        }}
      />
      {activityListData?.totalRecords > 0 && (
        <div className='txtRightAlign'>
          {activityListData?.totalRecords} total items
        </div>
      )}
    </div>
  );
};
